import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_RESPONSE_TYPES = "/api/response_types"

export async function getResponseTypes(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_TYPES
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getResponseType(id) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_TYPES + "/" + id
  return await getObject(url)
}

export async function putResponseType(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_TYPES + "/" + id
  return await putObject(url, putValues)
}

export async function patchResponseType(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_TYPES + "/" + id
  return await patchObject(url, patchValues)
}

export async function postResponseType(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_RESPONSE_TYPES
  return await postObject(url, postValues)
}
